import type { Device } from '@packages/shared/src/utils/types';
import { templates } from './config';
import type { Template, TemplateConfig } from './types';

/**
 * Method to return the template name and image dimensions by determining a breakpoint depending on the device type.
 *
 * You can specify a "type", to choose where your image is placed (controls which template is choosen).
 *
 * @param type - constant `compact`, `gallery`, `thumbnail`, or `zoom`, depending on where the image is placed
 * @returns object containing the akamai-template suffix string to append to a img-src and the image dimensions.
 */
export function getResponsiveAkamaiTemplate(
  type: keyof TemplateConfig,
  detectedDevice: Device,
): Template {
  return templates[type][detectedDevice];
}
